"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataFilterContainer = exports.useDataFilterContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Button_1 = require("../../components/Button");
require("./DataFilter.css");
var classnames_1 = __importDefault(require("classnames"));
var R = __importStar(require("../../utils/ramda"));
var useEmitter_1 = require("../../hooks/useEmitter");
var DataFilterContext_1 = require("./DataFilterContext");
var Stack_1 = require("../../components/Stack");
var Row_1 = require("../../components/Row");
var ListView_1 = require("../../components/ListView");
var MDIcon_1 = require("../../components/MDIcon");
var Popover_1 = require("../../components/Popover");
var intl_1 = require("./intl");
var countActiveFilters = function (filterStates) {
  return R.count(function (state) {
    var sel = state.optionsSelected.length;
    var incl = state.optionsIncluded.length;
    var excl = state.optionsExcluded.length;
    return sel + incl + excl > 0;
  }, Object.values(filterStates));
};
/** Returns a collection of state management objects.
 * @example
 * const config = useDataFilterContainer()
 * return (
 *  <DataFilterContainer {...config}>
 *      {children}
 *  </DataFilterContainer>
 * )
 */
var useDataFilterContainer = function () {
  var _a = __read((0, react_1.useState)({}), 2),
    filterStates = _a[0],
    setFilterStates = _a[1];
  var _b = __read((0, react_1.useState)({}), 2),
    tempStates = _b[0],
    setTempStates = _b[1];
  var _c = __read((0, react_1.useState)({}), 2),
    defaultStates = _c[0],
    setDefaultStates = _c[1];
  var unsavedChanges = (0, react_1.useMemo)(function () {
    return !R.equals(tempStates, filterStates);
  }, [tempStates, filterStates]);
  var activeFilterCount = (0, react_1.useMemo)(function () {
    return countActiveFilters(filterStates);
  }, [filterStates]);
  var resetEvent = (0, useEmitter_1.useEmitter)();
  return {
    /** The currently-applied states of each filter. */
    filterStates: filterStates,
    setFilterStates: setFilterStates,
    /** The currently-selected states of each filter, not necessarily having been applied. */
    tempStates: tempStates,
    setTempStates: setTempStates,
    /** The states to which the filters return after clicking RESET. */
    defaultStates: defaultStates,
    setDefaultStates: setDefaultStates,
    /** Boolean value which is `true` if `tempStates` and `filterStates` are different, otherwise `false`.  */
    unsavedChanges: unsavedChanges,
    /** Indiciates how many entries in `filterStates` are active. */
    activeFilterCount: activeFilterCount,
    /** Triggers secondary actions that need to be performed when resetting to default states in certain filter types.
     *  @example
     * resetEvent.emit("reset")
     */
    resetEvent: resetEvent
  };
};
exports.useDataFilterContainer = useDataFilterContainer;
var DataFilterContainer = function (_a) {
  var _b = _a.onDataChange,
    onDataChange = _b === void 0 ? R.N : _b,
    children = _a.children,
    onClose = _a.onClose,
    className = _a.className,
    filterStates = _a.filterStates,
    setFilterStates = _a.setFilterStates,
    tempStates = _a.tempStates,
    setTempStates = _a.setTempStates,
    defaultStates = _a.defaultStates,
    setDefaultStates = _a.setDefaultStates,
    unsavedChanges = _a.unsavedChanges,
    activeFilterCount = _a.activeFilterCount,
    resetEvent = _a.resetEvent,
    intl = _a.intl,
    _restProps = __rest(_a, ["onDataChange", "children", "onClose", "className", "filterStates", "setFilterStates", "tempStates", "setTempStates", "defaultStates", "setDefaultStates", "unsavedChanges", "activeFilterCount", "resetEvent", "intl"]);
  var translation = (0, react_1.useMemo)(function () {
    return (0, intl_1.createDataFilterIntl)(intl);
  }, [intl]);
  var restProps = R.omit(["setAllFilterStates"], _restProps);
  var applyFilters = function () {
    setFilterStates(tempStates);
    onDataChange(Object.values(tempStates));
  };
  var resetFilters = function () {
    resetEvent.emit("reset");
    setTempStates(defaultStates);
    setFilterStates(defaultStates);
    onDataChange(Object.values(defaultStates));
  };
  var setState = function (id, value, force, initial) {
    setTempStates(function (data) {
      var _a;
      return __assign(__assign({}, data), (_a = {}, _a[id] = value, _a));
    });
    if (force) {
      setFilterStates(function (data) {
        var _a;
        return __assign(__assign({}, data), (_a = {}, _a[id] = value, _a));
      });
    }
    if (initial) {
      setDefaultStates(function (data) {
        var _a;
        return __assign(__assign({}, data), (_a = {}, _a[id] = value, _a));
      });
    }
  };
  var titleText = (0, react_1.useMemo)(function () {
    if (activeFilterCount === 0) {
      return translation.filters;
    }
    if (activeFilterCount === 1) {
      return "1 ".concat(translation.activeFilter);
    }
    return "".concat(activeFilterCount, " ").concat(translation.activeFilters);
  }, [activeFilterCount]);
  var _c = __read((0, react_1.useState)(false), 2),
    hoverCloseButton = _c[0],
    setHoverCloseButton = _c[1];
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    className: (0, classnames_1.default)("vsx-data-filter-container", className),
    gap: "large"
  }, restProps, {
    children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      className: "vsx-data-filter-container-title",
      justify: "space-between",
      align: "center"
    }, {
      children: [(0, jsx_runtime_1.jsx)("span", __assign({}, {
        children: titleText
      })), onClose && (0, jsx_runtime_1.jsx)(Popover_1.Popover, __assign({
        interactive: false,
        shown: hoverCloseButton,
        tooltip: true,
        content: "Close filters"
      }, {
        children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
          onMouseEnter: function () {
            return setHoverCloseButton(true);
          },
          onMouseLeave: function () {
            return setHoverCloseButton(false);
          },
          onClick: function () {
            onClose();
            setHoverCloseButton(false);
          },
          className: "vsx-data-filter-close-icon",
          icon: "close"
        })
      }))]
    })), (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      gap: "medium",
      className: "vsx-data-filter-main-button-panel"
    }, {
      children: [(0, jsx_runtime_1.jsx)(Button_1.Button, __assign({
        type: "primary",
        disabled: !unsavedChanges,
        onClick: applyFilters
      }, {
        children: translation.applyButton
      })), (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({
        type: "tertiary",
        disabled: activeFilterCount === 0,
        onClick: resetFilters
      }, {
        children: translation.resetButton
      })), unsavedChanges && (0, jsx_runtime_1.jsx)(Popover_1.HoverPopover, __assign({
        tooltip: true,
        distance: -10,
        content: "Some filters have unapplied changes.",
        wrapperProps: {
          className: "unsaved-indicator"
        }
      }, {
        children: (0, jsx_runtime_1.jsx)("span", __assign({
          className: "unsaved-indicator-text"
        }, {
          children: translation.unappliedChanges
        }))
      }))]
    })), (0, jsx_runtime_1.jsx)(DataFilterContext_1.DataFilterContext.Provider, __assign({
      value: {
        tempStates: tempStates,
        filterStates: filterStates,
        defaultStates: defaultStates,
        setState: setState,
        resetEvent: resetEvent,
        translation: translation
      }
    }, {
      children: (0, jsx_runtime_1.jsx)(ListView_1.ListView, {
        data: children,
        className: "vsx-data-filter-list",
        itemStyle: {
          padding: "0"
        },
        renderContent: function (c) {
          return (0, jsx_runtime_1.jsx)(react_1.Fragment, {
            children: c
          });
        }
      })
    }))]
  }));
};
exports.DataFilterContainer = DataFilterContainer;